export const genderItems = [
  { text: "All", value: "" },
  { text: "Male", value: "male" },
  { text: "Female", value: "female" },
];

export const ageItems = [
  { text: "All", value: "" },
  { text: "0 yrs", value: 0 },
  { text: "1 yr", value: 1 },
  { text: "2 yrs", value: 2 },
  { text: "3 yrs", value: 3 },
  { text: "4 yrs", value: 4 },
  { text: "5+ yrs", value: 5 },
];

export function formatAgeFilterLabel(age: number): string {
  const item = ageItems.find((i) => i.value === age);
  return item ? item.text : `${age} yrs`;
}

export const statusItems = [
  { text: "All", value: "" },
  { text: "Planned Attendance", value: "attending" },
  { text: "Planned Absence", value: "isAbsent" },
  { text: "In School", value: "inSchool" },
  { text: "Went Home", value: "wentHome" },
  { text: "Absence Reported", value: "absenceReported" },
  { text: "Absence Cancellation Reported", value: "absenceCancellationReported" },
];

export const staffStatusItems = [
  { text: "Scheduled Absent", value: "isAbsent" },
  { text: "Scheduled to Work", value: "attending" },
  { text: "Clocked In", value: "inSchool" },
  { text: "Clocked Out", value: "wentHome" },
];
